const Search = ({ size=20, color="#000000", ...props }) => (
    <svg
        height={size}
        width={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="m21 21-4.34-4.34"/>
        <circle cx="11" cy="11" r="8"/>
    </svg>
);

export default Search;
